export class EpiFormsSteps {
    constructor() {

        // funtion for gettign progress bar start
        let progressContainer = document.querySelectorAll('.Form__NavigationBar__ProgressBar');

        if (!progressContainer || progressContainer.length < 1)
            return;

        var currentStep;

        var clickProgressNext = function () {
            setTimeout(function () {
                if (currentStep < Number(document.querySelectorAll('.Form__NavigationBar__ProgressBar__CurrentStep')[0].innerHTML)) {
                    var prevCurrentStep = currentStep;

                    currentStep = Number(document.querySelectorAll('.Form__NavigationBar__ProgressBar__CurrentStep')[0].innerHTML);
                    document.querySelectorAll('[data-step="' + currentStep + '"]')[0].classList.add('active');
                    document.querySelectorAll('[data-step="' + prevCurrentStep + '"]')[0].classList.remove('active');
                    document.querySelectorAll('[data-step="' + prevCurrentStep + '"]')[0].classList.add('done');

                }
            }, 500);

        }

        var clickProgressPrev = function () {
            setTimeout(function () {
                if (currentStep > Number(document.querySelectorAll('.Form__NavigationBar__ProgressBar__CurrentStep')[0].innerHTML)) {
                    var prevCurrentStep = currentStep;
                    currentStep = Number(document.querySelectorAll('.Form__NavigationBar__ProgressBar__CurrentStep')[0].innerHTML);
                    document.querySelectorAll('[data-step="' + prevCurrentStep + '"]')[0].classList.remove('active');
                    document.querySelectorAll('[data-step="' + currentStep + '"]')[0].classList.remove('done');
                    document.querySelectorAll('[data-step="' + currentStep + '"]')[0].classList.add('active');

                }
            }, 500);

        }


        if (progressContainer) {
            var numberOfAllSteps = Number(document.querySelectorAll('.Form__NavigationBar__ProgressBar__StepsCount')[0].innerHTML);


            // building html elements
            var stepsHTMLWrapper = document.createElement('div');
            stepsHTMLWrapper.classList.add('form-steps-container');

            for (var i = 0; i < numberOfAllSteps; i++) {
                var stepNumber = (i + 1).toString();
                var stepsHTMLChild = document.createElement('div');
                stepsHTMLChild.classList.add('form-steps-container-item');
                stepsHTMLChild.setAttribute('data-step', stepNumber);
                var stepsHTMLChildIcon = document.createElement('div');
                stepsHTMLChildIcon.classList.add('form-steps-container-item-icon');
                var stepsHTMLChildIconSVG = '<div class="form-steps-container-item-icon-svg"><svg><use xlink:href="#icon-checked"></use></svg></div>';
                var stepsHTMLChildIconText = document.createElement('div');
                stepsHTMLChildIconText.classList.add('form-steps-container-item-icon-text');
                var stepsHTMLChildIconTextNode = document.createTextNode(stepNumber);
                var stepsHTMLChildText = document.createElement('div');
                stepsHTMLChildText.classList.add('form-steps-container-item-text');
                var stepsHTMLChildTextNode = document.createTextNode(document.querySelectorAll('.FormStep__Title')[i].innerHTML);
                stepsHTMLChildIconText.appendChild(stepsHTMLChildIconTextNode);
                stepsHTMLChildIcon.appendChild(stepsHTMLChildIconText);
                stepsHTMLChildIcon.insertAdjacentHTML('afterbegin', stepsHTMLChildIconSVG);
                stepsHTMLChildText.appendChild(stepsHTMLChildTextNode);
                stepsHTMLChild.appendChild(stepsHTMLChildIcon);
                stepsHTMLChild.appendChild(stepsHTMLChildText);
                stepsHTMLWrapper.appendChild(stepsHTMLChild);
            }

            currentStep = document.querySelectorAll('.Form__NavigationBar__ProgressBar__CurrentStep')[0].innerHTML;
            var btnNext = document.querySelectorAll('button.btnNext')[0];
            var btnPrev = document.querySelectorAll('button.btnPrev')[0];
            btnNext.addEventListener('click', clickProgressNext);
            btnPrev.addEventListener('click', clickProgressPrev);

            document.querySelectorAll('.Form__MainBody')[0].insertBefore(stepsHTMLWrapper, document.querySelectorAll('.Form__MainBody')[0].firstChild);

            document.querySelectorAll('[data-step="' + currentStep + '"]')[0].classList.add('active');

        }

    }
}


// WEBPACK FOOTER //
// ./Static/javascript/modules/epi-forms-steps.ts